// PKCE (RFC 7636) helpers. Uses the browser SubtleCrypto API.

function base64UrlEncode(bytes: Uint8Array): string {
  let str = "";
  for (const byte of bytes) {
    str += String.fromCharCode(byte);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomBytes(length: number): Uint8Array {
  const arr = new Uint8Array(length);
  crypto.getRandomValues(arr);
  return arr;
}

export function generateCodeVerifier(): string {
  // RFC 7636 §4.1: 43..128 chars from [A-Z][a-z][0-9]-._~. 32 random bytes
  // base64url-encoded gives 43 chars, comfortably within spec.
  return base64UrlEncode(randomBytes(32));
}

export async function codeChallengeFromVerifier(verifier: string): Promise<string> {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64UrlEncode(new Uint8Array(digest));
}

export function generateState(): string {
  return base64UrlEncode(randomBytes(16));
}
